import Theme from "../themes";

const useTheme = () => Theme.light;

export default useTheme;
